import { WorkflowsSection } from './WorkflowSection'

export default WorkflowsSection